/** Current credit balance summary card */

import { Coins } from 'lucide-react'
import { cn } from '../../lib/utils'
import type { CreditBalance } from '../../hooks/use-credits'

interface Props {
  balance: CreditBalance | undefined
  isLoading: boolean
  isDark: boolean
}

export function CreditBalanceCard({ balance, isLoading, isDark }: Props) {
  return (
    <div
      className={cn(
        'rounded-xl border p-5',
        isDark ? 'border-white/[0.06] bg-surface-1' : 'border-neutral-200 bg-white',
      )}
    >
      <div className="flex items-center gap-2">
        <Coins className={cn('h-4 w-4', isDark ? 'text-neutral-500' : 'text-neutral-400')} />
        <span className={cn('text-xs font-medium uppercase tracking-wider', isDark ? 'text-neutral-500' : 'text-neutral-400')}>
          Current balance
        </span>
      </div>

      <div className="mt-3 flex items-baseline gap-2">
        <span className={cn('text-3xl font-bold', isDark ? 'text-neutral-100' : 'text-neutral-900')}>
          {isLoading ? '—' : (balance?.totalCredits ?? 0).toLocaleString()}
        </span>
        <span className={cn('text-sm', isDark ? 'text-neutral-500' : 'text-neutral-400')}>credits</span>
      </div>

      {balance && (balance.purchasedCredits > 0 || balance.freeCredits > 0) && (
        <div className={cn('mt-3 flex gap-4 text-xs', isDark ? 'text-neutral-500' : 'text-neutral-500')}>
          <span>
            <span className={cn(isDark ? 'text-neutral-300' : 'text-neutral-700')}>{balance.purchasedCredits.toLocaleString()}</span> purchased
          </span>
          <span>
            <span className={cn(isDark ? 'text-neutral-300' : 'text-neutral-700')}>{balance.freeCredits.toLocaleString()}</span> free
          </span>
        </div>
      )}
    </div>
  )
}
